import * as React from 'react';
export const AccordionItem = ({ children = null }) => (React.createElement(React.Fragment, null, children));
AccordionItem.displayName = 'AccordionItem';
//# sourceMappingURL=AccordionItem.js.map